import React from 'react';
import './EditorialFeatures.css';

const EditorialFeatures = () => {
  const features = [
    {
      title: 'The Zulu Beadwork Story',
      subtitle: 'Intricate patterns, timeless craftsmanship',
      excerpt: 'Explore the vibrant world of authentic Zulu beaded accessories. Each piece tells a story of tradition, artistry, and South African heritage.',
      cta: 'Shop Beaded Accessories',
      image: '🪡', // Using emoji placeholder, replace with actual image
      color: 'clay',
      link: '/products?culture=zulu&category=beadwork'
    },
    {
      title: 'Afrikaans Heritage Essentials',
      subtitle: 'Tradition meets contemporary style',
      excerpt: 'Discover curated collections celebrating Afrikaans cultural identity. From ceremonial pieces to everyday elegance, find your heritage.',
      cta: 'Explore Collection',
      image: '👗',
      color: 'olive',
      link: '/products?culture=afrikaans'
    },
    {
      title: 'Vernacular Stories',
      subtitle: 'Local languages, global craftsmanship',
      excerpt: 'Connect with South African artisans through our vernacular collection. Supporting local makers, preserving cultural narratives.',
      cta: 'Discover Stories',
      image: '📖',
      color: 'brass',
      link: '/stories'
    }
  ];

  return (
    <section className="editorial-features section">
      <div className="container">
        <div className="editorial-features__grid">
          {features.map((feature, index) => (
            <article 
              key={index}
              className={`editorial-tile editorial-tile--${feature.color}`}
            >
              <div className="editorial-tile__image-section">
                <div className="editorial-tile__image">
                  {feature.image}
                </div>
              </div>
              
              <div className="editorial-tile__content">
                <div className="editorial-tile__header">
                  <h3 className="editorial-tile__title">{feature.title}</h3>
                  <p className="editorial-tile__subtitle">{feature.subtitle}</p>
                </div>
                
                <p className="editorial-tile__excerpt">{feature.excerpt}</p>
                
                <a href={feature.link} className="editorial-tile__cta">
                  {feature.cta}
                  <span className="editorial-tile__arrow">→</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EditorialFeatures;
